<!--UrlNav:移动端Pad浏览器定制首页 2020/07/08 14:26:54 WangXin-->

<template>
  <div class="box-card">
    <div v-for="(list,index) in linkInfo" :key="index" class="link2">
      <a :href="list.url" target="_blank" rel="noopener noreferrer nofollow">
        <img class="its-src" :src="list.icon">
        <div class="its-span">
          <span class="link_name">{{list.name}}</span>
        </div>
      </a>
    </div>
    <div v-for="(list,index) in fixLength" :key="'fix' + index" class="link2">
    </div>
  </div>
</template>

<script>
import { controlApi } from '../../utils/api'
export default {
  name: "UrlNav",
  data() {
    return {
      linkInfo: [] //预制链接数据
    }
  },
  computed: {
    columNUm() {
      return (document.body.clientWidth / 192).toFixed()
    },
    needFix() {
      return this.linkInfo.length % this.columNUm
    },
    fixLength() {
      if (this.linkInfo.length < this.columNUm) {
        return []
      } else {
        return new Array((this.columNUm - this.needFix))
      }
    }
  },
  mounted() {
    this.selectControlPresetUrl()
    /*this.linkInfo = [
                        {
                          name: "学科网主站",
                          url: "http://www.zxxk.com",
                          icon: "images/xkw2.png"
                        },
                        {
                          name: "小学学科网",
                          url: "http://www.xuekeedu.com",
                          icon: "images/xkw1.png"
                        },
                        {
                          name: "中学学科网",
                          url: "http://middle.school.zxxk.com",
                          icon: "images/xkw2.png"
                        },
                        {
                          name: "高中学科网",
                          url: "http://high.school.zxxk.com",
                          icon: "images/xkw2.png"
                        },
                        {
                          name: "学科网视频",
                          url: "http://sp.zxxk.com",
                          icon: "images/xkw2.png"
                        },
                        {
                          name: "学科网书城",
                          url: "http://b.zxxk.com",
                          icon: "images/xkw2.png"
                        },
                        {
                          name: "学科头条",
                          url: "http://news.zxxk.com",
                          icon: "images/xkw3.png"
                        }
                    ]
    */

  },
  methods: {
    selectControlPresetUrl: function () {
      let time = localStorage.getItem('requestPresetUrlTime')
      let now = Date.parse(new Date())
      if (time === null || (now - time) / 60 / 1000 > 1) {
        controlApi.selectControlPresetUrl().then((data) => {
          let res = data.body
          if (res.success) {
            this.linkInfo = res.resultObject
            localStorage.setItem('presetUrlLinkInfo', JSON.stringify(res.resultObject));
            localStorage.setItem('requestPresetUrlTime', now + '');
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        this.linkInfo = JSON.parse(localStorage.getItem('presetUrlLinkInfo'))
      }
    }
  }
};
</script>

<style scoped>
.box-card {
  min-height: 100vh;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: baseline;
}
a {
  display: block;
  width: 115px;
  height: 100%;
  color: #000;
  text-decoration: none;
  margin-left: 39px;
  margin-right: 39px;
  margin-top: 20px;
}
.link2 {
  display: inline-block;
  width: 192px;
  text-align: center;
  padding: 5px 0;
  overflow: hidden;
}
.link2:after {
  content: "";
  flex: auto;
}
.its-src {
  display: inline-block;
  width: 115px;
  height: 115px;
  text-align: center;
  overflow: hidden;
}
.its-span {
  text-align: center;
  margin-top: 6px;
}
.box-card {
  background-color: #dedede;
}
body {
  padding-bottom: env(safe-area-inset-bottom);
  -webkit-text-size-adjust: 100%;
}
</style>